const Shimmer = () => {
  return (
    <div className="shimmer">
      <div className="shimmer-top w-full h-[40vh] bg-shimmer-color mb-8  animate-pulse duration-75 "></div>

      <div className="shimmer-cards container flex-center flex-wrap h-[100vh] ">
        <div className="dummy-card animate-pulse duration-75 w-[200px] h-60 m-[15px] bg-white shadow-lg   ">
          <div className="shimmer-img bg-shimmer-color h-1/2 "></div>
          <div className="shimmer-line1 h-[10px] w-[90%] bg-shimmer-color my-5 mx-1 "></div>
          <div className="shimmer-line2 h-[10px] w-[70%] bg-shimmer-color my-5 mx-1"></div>
        </div>
        <div className="dummy-card animate-pulse duration-75 w-[200px] h-60 m-[15px] bg-white shadow-lg   ">
          <div className="shimmer-img bg-shimmer-color h-1/2 "></div>
          <div className="shimmer-line1 h-[10px] w-[90%] bg-shimmer-color my-5 mx-1 "></div>
          <div className="shimmer-line2 h-[10px] w-[70%] bg-shimmer-color my-5 mx-1"></div>
        </div>
        <div className="dummy-card animate-pulse duration-75 w-[200px] h-60 m-[15px] bg-white shadow-lg   ">
          <div className="shimmer-img bg-shimmer-color h-1/2 "></div>
          <div className="shimmer-line1 h-[10px] w-[90%] bg-shimmer-color my-5 mx-1 "></div>
          <div className="shimmer-line2 h-[10px] w-[70%] bg-shimmer-color my-5 mx-1"></div>
        </div>
        <div className="dummy-card animate-pulse duration-75 w-[200px] h-60 m-[15px] bg-white shadow-lg   ">
          <div className="shimmer-img bg-shimmer-color h-1/2 "></div>
          <div className="shimmer-line1 h-[10px] w-[90%] bg-shimmer-color my-5 mx-1 "></div>
          <div className="shimmer-line2 h-[10px] w-[70%] bg-shimmer-color my-5 mx-1"></div>
        </div>
        <div className="dummy-card animate-pulse duration-75 w-[200px] h-60 m-[15px] bg-white shadow-lg   ">
          <div className="shimmer-img bg-shimmer-color h-1/2 "></div>
          <div className="shimmer-line1 h-[10px] w-[90%] bg-shimmer-color my-5 mx-1 "></div>
          <div className="shimmer-line2 h-[10px] w-[70%] bg-shimmer-color my-5 mx-1"></div>
        </div>
        <div className="dummy-card animate-pulse duration-75 w-[200px] h-60 m-[15px] bg-white shadow-lg   ">
          <div className="shimmer-img bg-shimmer-color h-1/2 "></div>
          <div className="shimmer-line1 h-[10px] w-[90%] bg-shimmer-color my-5 mx-1 "></div>
          <div className="shimmer-line2 h-[10px] w-[70%] bg-shimmer-color my-5 mx-1"></div>
        </div>
        <div className="dummy-card animate-pulse duration-75 w-[200px] h-60 m-[15px] bg-white shadow-lg   ">
          <div className="shimmer-img bg-shimmer-color h-1/2 "></div>
          <div className="shimmer-line1 h-[10px] w-[90%] bg-shimmer-color my-5 mx-1 "></div>
          <div className="shimmer-line2 h-[10px] w-[70%] bg-shimmer-color my-5 mx-1"></div>
        </div>
        <div className="dummy-card animate-pulse duration-75 w-[200px] h-60 m-[15px] bg-white shadow-lg   ">
          <div className="shimmer-img bg-shimmer-color h-1/2 "></div>
          <div className="shimmer-line1 h-[10px] w-[90%] bg-shimmer-color my-5 mx-1 "></div>
          <div className="shimmer-line2 h-[10px] w-[70%] bg-shimmer-color my-5 mx-1"></div>
        </div>
      </div>
    </div>
  );
};

export default Shimmer;
